module.exports = {"id":"177019","name":"Fabian Lustenberger","rating":"76","photo":"./data/images/photos/3/177019.png","club":{"name":"Hertha Berlin","logo":"./data/images/clubs/HerthaBerlin.png"},"positions":["MDC","DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabianLustenberger0.json
// module id = 1331
// module chunks = 0